import React, { createContext, useContext, useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Calendar from './pages/Calendar';
import Tasks from './pages/Tasks';
import Meals from './pages/Meals';
import Memory from './pages/Memory';
import Documents from './pages/Documents';
import Settings from './pages/Settings';
import AI from './pages/AI';
import Emails from './pages/Emails';
import Help from './pages/Help';
import Maison from './pages/Maison';
import Shopping from './pages/Shopping';
import Birthdays from './pages/Birthdays';
import Navbar from './components/Navbar';
import QuickAdd from './components/QuickAdd';

export const AuthContext = createContext(null);

export function useAuth() { return useContext(AuthContext); }

function PrivateRoute({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" replace />;
}

function AppLayout({ children }) {
  const [quickAddOpen, setQuickAddOpen] = useState(false);
  const [quickAddType, setQuickAddType] = useState('evenement');

  const openQuickAdd = (type = 'evenement') => { setQuickAddType(type); setQuickAddOpen(true); };

  const location = useLocation();
  const hideFab = location.pathname !== '/';

  return (
    <div className="app-container">
      {children}
      {!hideFab && <button className="fab" onClick={() => openQuickAdd()} title="Ajouter rapidement">+</button>}
      <Navbar />
      {quickAddOpen && <QuickAdd type={quickAddType} onClose={() => setQuickAddOpen(false)} />}
    </div>
  );
}

export default function App() {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('family_user')); } catch { return null; }
  });

  useEffect(() => {
    const token = localStorage.getItem('family_token');
    if (!token) return;
    fetch('/api/auth/me', { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (data) {
          localStorage.setItem('family_user', JSON.stringify(data));
          setUser(data);
        }
      })
      .catch(() => {});
  }, []);

  const login = (token, userData) => {
    localStorage.setItem('family_token', token);
    localStorage.setItem('family_user', JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('family_token');
    localStorage.removeItem('family_user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
          <Route path="/" element={<PrivateRoute><AppLayout><Dashboard /></AppLayout></PrivateRoute>} />
          <Route path="/agenda" element={<PrivateRoute><AppLayout><Calendar /></AppLayout></PrivateRoute>} />
          <Route path="/taches" element={<PrivateRoute><AppLayout><Tasks /></AppLayout></PrivateRoute>} />
          <Route path="/repas" element={<PrivateRoute><AppLayout><Meals /></AppLayout></PrivateRoute>} />
          <Route path="/memoire" element={<PrivateRoute><AppLayout><Memory /></AppLayout></PrivateRoute>} />
          <Route path="/documents" element={<PrivateRoute><AppLayout><Documents /></AppLayout></PrivateRoute>} />
          <Route path="/maison" element={<PrivateRoute><AppLayout><Maison /></AppLayout></PrivateRoute>} />
          <Route path="/courses" element={<PrivateRoute><AppLayout><Shopping /></AppLayout></PrivateRoute>} />
          <Route path="/emails" element={<PrivateRoute><AppLayout><Emails /></AppLayout></PrivateRoute>} />
          <Route path="/ia" element={<PrivateRoute><AppLayout><AI /></AppLayout></PrivateRoute>} />
          <Route path="/anniversaires" element={<PrivateRoute><AppLayout><Birthdays /></AppLayout></PrivateRoute>} />
          <Route path="/aide" element={<PrivateRoute><AppLayout><Help /></AppLayout></PrivateRoute>} />
          <Route path="/parametres" element={<PrivateRoute><AppLayout><Settings /></AppLayout></PrivateRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthContext.Provider>
  );
}
